import { render, staticRenderFns } from "./DateField.form-builder.vue?vue&type=template&id=06e72990&"
import script from "./DateField.form-builder.vue?vue&type=script&lang=js&"
export * from "./DateField.form-builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports